import { Button, Col, DatePicker, Input, Row, Select } from 'antd'
import moment from 'moment'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { labelForAction, PORTALS } from '../../constants'

const { RangePicker } = DatePicker
const { Option } = Select

/**
 * Filter bar for the audit log.
 *
 * Filters are applied on submit rather than on every keystroke: each change
 * restarts cursor paging from the top, so applying on change would throw away
 * loaded pages while the user is still typing.
 */
const AuditFilter = ({ actions, entityTypes, isLoading, onApply, onReset }) => {
  const [range, setRange] = useState(null)
  const [action, setAction] = useState(undefined)
  const [entityType, setEntityType] = useState(undefined)
  const [actorId, setActorId] = useState('')
  const [portal, setPortal] = useState(undefined)

  const handleApply = () => {
    onApply({
      from: range?.[0] ? moment(range[0]).startOf('day').toISOString() : undefined,
      to: range?.[1] ? moment(range[1]).endOf('day').toISOString() : undefined,
      action,
      entityType,
      actorId: actorId.trim() || undefined,
      portal,
    })
  }

  const handleReset = () => {
    setRange(null)
    setAction(undefined)
    setEntityType(undefined)
    setActorId('')
    setPortal(undefined)
    onReset()
  }

  return (
    <Row gutter={[12, 12]} align="bottom" style={{ marginBottom: 16 }}>
      <Col xs={24} sm={12} md={7}>
        <label htmlFor="audit-range">When</label>
        <RangePicker
          id="audit-range"
          value={range}
          onChange={setRange}
          style={{ width: '100%' }}
          allowClear
        />
      </Col>
      <Col xs={24} sm={12} md={5}>
        <label htmlFor="audit-action">Action</label>
        <Select
          id="audit-action"
          value={action}
          onChange={setAction}
          placeholder="All actions"
          style={{ width: '100%' }}
          allowClear
          showSearch
          optionFilterProp="children"
        >
          {actions.map((item) => (
            <Option key={item} value={item}>
              {labelForAction(item)}
            </Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} sm={12} md={4}>
        <label htmlFor="audit-entity">Entity</label>
        <Select
          id="audit-entity"
          value={entityType}
          onChange={setEntityType}
          placeholder="All entities"
          style={{ width: '100%' }}
          allowClear
        >
          {entityTypes.map((item) => (
            <Option key={item} value={item}>
              {item.replace(/_/g, ' ')}
            </Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} sm={12} md={4}>
        <label htmlFor="audit-portal">Portal</label>
        <Select
          id="audit-portal"
          value={portal}
          onChange={setPortal}
          placeholder="All portals"
          style={{ width: '100%' }}
          allowClear
        >
          {PORTALS.map((item) => (
            <Option key={item} value={item}>
              {item}
            </Option>
          ))}
        </Select>
      </Col>
      <Col xs={24} sm={12} md={4}>
        <label htmlFor="audit-actor">Actor id</label>
        <Input
          id="audit-actor"
          value={actorId}
          onChange={(event) => setActorId(event.target.value)}
          placeholder="User id"
          onPressEnter={handleApply}
          allowClear
        />
      </Col>
      <Col xs={24}>
        <Button type="primary" onClick={handleApply} loading={isLoading}>
          Apply
        </Button>
        <Button onClick={handleReset} style={{ marginLeft: 8 }}>
          Reset
        </Button>
      </Col>
    </Row>
  )
}

AuditFilter.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.string),
  entityTypes: PropTypes.arrayOf(PropTypes.string),
  isLoading: PropTypes.bool,
  onApply: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
}

AuditFilter.defaultProps = {
  actions: [],
  entityTypes: [],
  isLoading: false,
}

export default AuditFilter
